import { Profanity } from '@2toad/profanity';
import { Injectable } from '@angular/core';
import { permittedProfanityWords } from 'src/lib/constants/constants';

@Injectable({
	providedIn: 'root',
})
export class ProfanityService {
	private p = new Profanity({ grawlix: '****' });

	constructor() {
		this.p.whitelist.addWords(permittedProfanityWords);
	}

	public get profanity(): Profanity {
		return this.p;
	}

	public exists(words: string): boolean {
		return this.p.exists(words);
	}

	public censor(words: string): string {
		return this.p.censor(words);
	}
}
